import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";


const LineChartDayDecimals = (props) => {
  const symbol = props.symbol || '';

  // Transformar los datos para el gráfico
  const transformData = () => {
    if (!props.valueY || !Array.isArray(props.valueY)) {
      return { xAxisData: [], seriesData: [] };
    }

    const xAxisData = [];
    const seriesData = [];

    props.valueY.forEach(item => {
      if (item.value && Array.isArray(item.value) && item.value.length >= 2) {
        xAxisData.push(item.value[0]); // La fecha (ej: "02 mar.")
        const numericValue = parseFloat(item.value[1]); // El valor numérico
        seriesData.push(isNaN(numericValue) ? 0 : numericValue);
      }
    });

    return { xAxisData, seriesData };
  };

  const { xAxisData, seriesData } = transformData();

  const getOptions = () => ({
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxisData, // Usar las fechas para el eje X
      axisLabel: {
        rotate: 30,
        interval: 0,
        fontSize: 12,
        color: '#333',
      }
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, '30%']
    },
    title: {
      text: props.title,
      subtext: props.subTitle,
      left: 'center'
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        if (params && params[0]) {
          return `${params[0].axisValue}<br/>${props.seriesTitle}: ${params[0].value}${symbol}`;
        }
        return '';
      }
    },
    legend: {
      left: 'center',
      top: 'bottom'
    },
    series: [
      {
        name: props.seriesTitle,
        type: 'line',
        smooth: true,
        data: seriesData, // Usar solo los valores numéricos
        label: {
          show: props.showSerieValue,
          position: 'top',
          formatter: (params) => {
            const value = params.value;
            if (typeof value === 'number' && !isNaN(value)) {
              return new Intl.NumberFormat('es-CO', {
                minimumFractionDigits: props.decimals || 0,
                maximumFractionDigits: props.decimals || 0,
              }).format(value) + symbol;
            }
            return '0' + symbol;
          }
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  });

  return (
    <div className="">
      <ReactEcharts
        ref={props.chartRef}
        option={getOptions()}
        style={{ height: 300 }}
      />
    </div>
  );
}

export default LineChartDayDecimals;